import React, { useState, useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../contexts/AuthContext';

interface EventProps 
{
  eventId: number;
  title: string;
  onSave: () => void;
  onCancel: () => void;
}

const Load: React.FC<EventProps> = ({ eventId, title, onSave, onCancel }) => 
{
  const { token } = useContext(AuthContext);
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);
  const modalRef = useRef<HTMLDivElement>(null); // Ref para el contenedor del modal  

  //-----------------------------------------------------------

  useEffect(() => 
  {
    // Función para manejar clics fuera del componente
    const handleClickOutside = (event: MouseEvent) => 
    {
      if (modalRef.current && !modalRef.current.contains(event.target as Node))
        onCancel();
    };

    // Función para manejar presiones de teclas
    const handleEscPress = (event: KeyboardEvent) => 
    {
      if (event.key === 'Escape') 
        onCancel();
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscPress);

    return () => 
    {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscPress);
    };
  }, [onCancel]);  

  //-----------------------------------------------------------

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => 
  {
    if (event.target.files) 
    {
      setFile(event.target.files[0]);
    }
  };

  //-----------------------------------------------------------

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => 
  {
    event.preventDefault(); // Previene el comportamiento por defecto del formulario

    try 
    {
        if (!file) 
        {
            setError('Por favor, selecciona un archivo.');
            return;
        }

        const formData = new FormData();
        formData.append('CSV_CODES', file);

        const api_url = process.env.REACT_APP_API_BASE_URL || '';
        const response = await fetch(`${api_url}batch/create_codes?id_event=${eventId}`, {
          method: 'POST',
          headers: {
              'X-AUTH-TOKEN': token || ''},      
          body: formData})

        if (response.ok) 
            onSave();
        else 
            throw new Error('Error al cargar CSV.');
    } 
    catch (error) 
    {
        setError('Error de red.');
    }
  };

  //-----------------------------------------------------------

  return (
    <div className="evento-container" ref={modalRef}>
      <h2>Cargar CSV de {title}</h2>
      <div className='sample_csv-container'>
        Ejemplo de CSV válido:<br/><br/>
        <i>code,response,type,tag,number_of_uses<br/>
        stbXDmFcUOLbldPO,Karen Walker,CTStreet,Before8pm,1<br/>
        MZG3sdrGZhnOlbQ5,Brian Hall,Worker,General,5<br/>
        C7Dzof6tCzzBlXgK,Kimberly Allen,Online,Before6pm,1<br/></i>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="file"
            onChange={handleFileChange}
          />
        </div>        
        {error && <p className="error-message">{error}</p>}
        <div className="form-actions">
          <button type="submit">Enviar</button>
          <button type="button" onClick={onCancel}>Cancelar</button>
        </div>        
      </form>
    </div>
  );
};

export default Load;
